<template>
	<div class="main">
		<el-form :model="form" label-width="100px" style="max-width: 800px;text-align: left;" :rules="rules" ref="ruleForm" label-position="left">
			<el-form-item label="新闻标题" prop="title"><el-input v-model="form.title"></el-input></el-form-item>
			<el-form-item label="新闻内容" prop="content">
				<el-card style="height: 610px;"><quill-editor v-model="form.content" ref="myQuillEditor" style="height: 500px;" :options="editorOption"></quill-editor></el-card>
			</el-form-item>
			<el-form-item style="margin-top: 20px;">
				<el-button type="primary" @click="submitForm('ruleForm')">立即创建</el-button>
				<el-button @click="resetForm('ruleForm')">重置</el-button>
				<el-button @click="turnBack">返回上页</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
// 富文本样式
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { addQuillTitle } from '@/plugins/quill-title.js';
import Quill from 'quill';
import { quillEditor } from 'vue-quill-editor';
import ImageResize from 'quill-image-resize-module'; //添加
import { ImageDrop } from 'quill-image-drop-module';
Quill.register('modules/imageDrop', ImageDrop);
Quill.register('modules/imageResize', ImageResize);
import { mapActions } from 'vuex';
export default {
	components: {
		quillEditor
	},
	data() {
		return {
			form: {
				id: '',
				title: '',
				content: '' //商品富文本详情
			},
			editorOption: {
				placeholder: '请输入内容',
				modules: {
					imageResize: {
						//添加
						displayStyles: {
							//添加
							backgroundColor: 'black',
							border: 'none',
							color: 'white'
						},
						modules: ['Resize', 'DisplaySize', 'Toolbar'] //添加
					},
					toolbar: [
						['bold', 'italic', 'underline', 'strike'],
						['blockquote', 'code-block'],
						[{ header: 1 }, { header: 2 }],
						[{ list: 'ordered' }, { list: 'bullet' }],
						[{ script: 'sub' }, { script: 'super' }],
						[{ indent: '-1' }, { indent: '+1' }],
						[{ direction: 'rtl' }],
						[{ size: ['small', false, 'large', 'huge'] }],
						[{ header: [1, 2, 3, 4, 5, 6, false] }],
						[{ color: [] }, { background: [] }],
						[{ font: [] }],
						[{ align: [] }],
						['clean'],
						['image', 'video','link']
					]
				}
			}, //富文本设置
			rules: {
				title: [{ required: true, message: '请输入新闻标题', trigger: 'blur' }, { min: 2, max: 100, message: '长度在 2 到 100 个字符', trigger: 'blur' }],
				content: [{ required: true, message: '请输入新闻内容', trigger: 'blur' }]
			}
		};
	},
	methods: {
		...mapActions({
			exit: 'auth/logout'
		}),
		getNewsInfo(id) {
			this.$axios({
				url: this.HOST + '/admin.news/getNewsInfo',
				method: 'post',
				data: {
					id: id,
					adminid: JSON.parse(this.$store.state.user.userInfo).id,
					token: JSON.parse(this.$store.state.user.userInfo).token
				}
			})
				.then(res => {
					console.log(res);
					if (res.data.status == 1) {
						this.form = res.data.newsInfo;
						// this.$router.go(-1);
					} else {
						this.$message.error(res.data.msg);
						if (res.data.status == 0) {
							if (res.data.admin_err == 'admininfo_error') {
								this.exit().then(res => {
									console.log(res);
									if (res.actionStatus == 1) {
										this.$router.push('/login');
									}
								});
							}
						}
					}
				})
				.catch(err => {});
		},
		submitForm(formName) {
			// console.log(this.form.content);
			this.$refs[formName].validate((valid, item) => {
				if (valid) {
					this.submitGoodsInfo();
				} else {
					console.log(item);
					for (let i in item) {
						this.$message.error(item[i][0].message);
						return false;
					}
				}
			});
		},
		resetForm(formName) {
			this.$refs[formName].resetFields();
		},
		submitGoodsInfo() {
			this.$axios({
				url: this.HOST + '/admin.news/addNews',
				method: 'post',
				data: {
					formData: this.form,
					adminid: JSON.parse(this.$store.state.user.userInfo).id,
					token: JSON.parse(this.$store.state.user.userInfo).token
				}
			})
				.then(res => {
					console.log(res);
					if (res.data.status == 1) {
						this.$message.success(res.data.msg);
						this.$router.go(-1);
					} else {
						this.$message.error(res.data.msg);
						if (res.data.status == 0) {
							if (res.data.admin_err == 'admininfo_error') {
								this.exit().then(res => {
									console.log(res);
									if (res.actionStatus == 1) {
										this.$router.push('/login');
									}
								});
							}
						}
					}
				})
				.catch(err => {});
		},
		turnBack(){
			this.$router.go(-1);
		}
	},
	mounted() {
		addQuillTitle();
		let news_id = this.$route.query.id;
		if (news_id) {
			this.getNewsInfo(news_id);
		}
	}
};
</script>

<style lang="scss">
div {
	box-sizing: border-box;
}
.phone-content {
	background: #f8f8f8;
	padding-bottom: 80px;
}
i:hover {
	color: #409eff;
	cursor: pointer;
}
.el-tag {
	margin: 0 10px 10px 0;
}
.ql-tooltip,
.ql-editing {
	margin-left: 0 !important;
}
.el-form-item__label {
	color: #000000 !important;
}
.phone {
	width: 394px;
	height: 667px;
	overflow: hidden;
	box-sizing: border-box;
	margin: 0 auto;
	border: 1px solid #ccc;
	text-align: left;
	position: relative;
}
.phone-content {
	height: 667px;
	overflow: scroll;
}
.ph-introduce-section {
	background: #fff;
	padding: 10px 15px;
}

.ph-title {
	font-size: 16px;
	color: #303133;
	line-height: 25px;
}
.price-box {
	display: flex;
	-webkit-box-align: baseline;
	-webkit-align-items: baseline;
	align-items: baseline;
	height: 32px;
	padding: 5px 0;
	font-size: 13px;
	color: #fa436a;
}
.bot-row {
	display: flex;
	-webkit-box-align: center;
	-webkit-align-items: center;
	align-items: center;
	height: 25px;
	font-size: 12px;
	color: #909399;
	justify-content: space-between;
}
.c-list {
	font-size: 13px;
	color: #606266;
	background: #fff;
}
.c-list .c-row {
	display: flex;
	-webkit-box-align: center;
	-webkit-align-items: center;
	align-items: center;
	padding: 10px 15px;
	position: relative;
}
.c-list .c-row:first-child {
	border-top: 0.5px solid #e4e7ed;
}
.c-list .c-row {
	border-bottom: 0.5px solid #e4e7ed;
}
.c-list .tit {
	width: 70px;
}
.c-list .con {
	flex: 1;
	color: #303133;
}
/* 评价 */
.eva-section {
	display: flex;
	flex-direction: column;
	padding: 10px 15px;
	background: #fff;
	margin-top: 8px;
	.e-header {
		display: flex;
		-webkit-box-align: center;
		-webkit-align-items: center;
		align-items: center;
		height: 35px;
		font-size: 13px;
		color: #909399;
		justify-content: space-between;
		.tit {
			font-size: 15px;
			color: #303133;
			margin-right: 2px;
		}
		.tip {
			flex: 1;
			text-align: right;
		}
		.icon-you {
			margin-left: 5px;
		}
	}
	.comment_more {
		text-align: center;
		color: #dd524d;
		font-size: 13px;
		height: 35px;
		line-height: 35px;
	}
}
.eva-box {
	display: flex;
	padding: 10px 0;
	.portrait {
		flex-shrink: 0;
		width: 40px;
		height: 40px;
		border-radius: 100px;
	}
	.right {
		flex: 1;
		display: flex;
		flex-direction: column;
		font-size: 14px;
		color: #606266;
		padding-left: 13px;
		.con {
			font-size: 14px;
			color: #303133;
			padding: 10px 0;
		}
		.bot {
			display: flex;
			justify-content: space-between;
			font-size: 12px;
			color: #909399;
		}
	}
}
.comment_pics {
	display: flex;
	justify-content: flex-start;
	margin-right: 5px;
	flex-flow: row wrap;
}
.comment_img {
	width: 70px;
	height: 70px;
}
.comment_more {
	text-align: center;
	color: #dd524d;
	font-size: 13px;
}
/* 底部操作菜单 */
.page-bottom {
	position: absolute;
	left: 15px;
	bottom: 15px;
	z-index: 95;
	display: flex;
	justify-content: center;
	align-items: center;
	width: 345px;
	height: 50px;
	background: rgba(255, 255, 255, 0.9);
	box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.5);
	border-radius: 8px;

	.p-b-btn {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		font-size: 12px;
		color: #606266;
		width: 48px;
		height: 40px;
		i {
			font-size: 20px;
			line-height: 24px;
			color: #909399;
		}
		&.active,
		&.active .yticon {
			color: #fa436a;
		}
		.icon-fenxiang2 {
			font-size: 21px;
			transform: translateY(-1px);
		}
		.icon-shoucang {
			font-size: 23px;
		}
	}
	.action-btn-group {
		display: flex;
		height: 38px;
		border-radius: 100px;
		overflow: hidden;
		box-shadow: 0 10px 20px -8px #fa436a;
		box-shadow: 1px 2px 5px rgba(219, 63, 96, 0.4);
		background: linear-gradient(to right, #ffac30, #fa436a, #f56c6c);
		margin-left: 10px;
		position: relative;
		&:after {
			content: '';
			position: absolute;
			top: 50%;
			right: 50%;
			transform: translateY(-50%);
			height: 14px;
			width: 0;
			border-right: 1px solid rgba(255, 255, 255, 0.5);
		}
		.action-btn {
			display: flex;
			align-items: center;
			justify-content: center;
			width: 90px;
			height: 100%;
			font-size: 14px;
			padding: 0;
			border-radius: 0;
			background: transparent;
		}
	}
}
/*  详情 */
.detail-desc {
	background: #fff;
	margin-top: 8px;
	.d-header {
		display: flex;
		justify-content: center;
		align-items: center;
		height: 40px;
		font-size: 30rpx;
		color: #303133;
		position: relative;

		text {
			padding: 0 10px;
			background: #fff;
			position: relative;
			z-index: 1;
		}
		&:after {
			position: absolute;
			left: 50%;
			top: 50%;
			transform: translateX(-50%);
			width: 150px;
			height: 0;
			content: '';
			border-bottom: 1px solid #ccc;
		}
	}
}
img {
	max-width: 100%;
}
.yunfeiIntro {
	position: absolute;
	width: 330px;
	left: 22px;
	top: 200px;
	border-radius: 7px;
	min-height: 200px;
	z-index: 5;
	background-color: #fff;
	border: 1px solid #ccc;
	box-shadow: 0 0 15px #ccc;
	.yfIntro-close {
		width: 100%;
		height: 40px;
		position: absolute;
		bottom: 0;
		line-height: 40px;
		color: #2f94ff;
		text-align: center;
		border-top: 1px solid #ccc;
		cursor: pointer;
	}
}
/* 规格选择弹窗 */
.attr-content {
	padding: 5px 15px;
	.a-t {
		display: flex;
		img {
			width: 85px;
			height: 85px;
			flex-shrink: 0;
			margin-top: -20px;
			border-radius: 4px;
		}
		.right {
			display: flex;
			flex-direction: column;
			padding-left: 12px;
			font-size: 26rpx;
			color: #606266;
			line-height: 21px;
			.price {
				font-size: 32rpx;
				color: #fa436a;
				margin-bottom: 5px;
			}
			.selected-text {
				margin-right: 5px;
			}
		}
	}
	.attr-list {
		display: flex;
		flex-direction: column;
		font-size: 30rpx;
		color: #606266;
		padding-top: 15px;
		padding-left: 5px;
	}
	.item-list {
		padding: 10px 0 0;
		display: flex;
		flex-wrap: wrap;
		span {
			display: flex;
			align-items: center;
			justify-content: center;
			background: #eee;
			margin-right: 10px;
			margin-bottom: 10px;
			border-radius: 50px;
			min-width: 30px;
			height: 30px;
			padding: 0 10px;
			font-size: 14px;
			color: #303133;
			cursor: pointer;
		}
		.selected {
			background: #fbebee;
			color: #fa436a;
		}
	}
}

/*  弹出层 */
.popup {
	position: absolute;
	left: 0;
	top: 0;
	right: 0;
	bottom: 0;
	z-index: 99;

	&.show {
		display: block;
		.mask {
			animation: showPopup 0.2s linear both;
		}
		.layer {
			animation: showLayer 0.2s linear both;
		}
	}
	&.hide {
		.mask {
			animation: hidePopup 0.2s linear both;
		}
		.layer {
			animation: hideLayer 0.2s linear both;
		}
	}
	&.none {
		display: none;
	}
	.mask {
		position: absolute;
		top: 0;
		width: 100%;
		height: 100%;
		z-index: 1;
		background-color: rgba(0, 0, 0, 0.4);
	}
	.layer {
		position: absolute;
		z-index: 99;
		bottom: 0;
		width: 100%;
		min-height: 40vh;
		border-radius: 5px 5px 0 0;
		background-color: #fff;
		.btn {
			// width: calc(100% - 30px);
			width: 100%;
			border-radius: 50px;
			background: #fa436a;
			font-size: 15px;
			color: #fff;
			margin: 15px auto 10px;
		}
	}
	@keyframes showPopup {
		0% {
			opacity: 0;
		}
		100% {
			opacity: 1;
		}
	}
	@keyframes hidePopup {
		0% {
			opacity: 1;
		}
		100% {
			opacity: 0;
		}
	}
	@keyframes showLayer {
		0% {
			transform: translateY(120%);
		}
		100% {
			transform: translateY(0%);
		}
	}
	@keyframes hideLayer {
		0% {
			transform: translateY(0);
		}
		100% {
			transform: translateY(120%);
		}
	}
}
.del_price {
	text-decoration: line-through;
	color: gray;
	font-size: 14px;
	margin-left: 15upx;
}
</style>
